import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { saveProcedure } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postProcedure({
  AccountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(saveProcedure(AccountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  AccountId: number;
  params: {
    Id: number;
    Content: string;
  };
};

type TSnapshot = unknown;

function useSaveProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ AccountId, params }: TVariables) => {
    const postResult = await postProcedure({
      AccountId,
      params,
    });
    if (postResult.Data) {
      //for broken link count updation
      queryClient.invalidateQueries(['get_broken_links', AccountId], {
        refetchInactive: true,
      });
      //dismissal tab update
      queryClient.invalidateQueries(['getBrokenLinksForDismissal', AccountId], {
        refetchInactive: true,
      });
      //publish flag changes
      queryClient.invalidateQueries(
        ['get_procedure_builder_procedures', AccountId],
        {
          refetchInactive: true,
        },
      );
    } else if (postResult.Errors) throw postResult;

    return postResult;
  });
}

export { useSaveProcedure };
